/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RecomandationStatusEnum,
    RecomandationStatusEnumFromJSON,
    RecomandationStatusEnumFromJSONTyped,
    RecomandationStatusEnumToJSON,
} from './RecomandationStatusEnum';

/**
 * 
 * @export
 * @interface RecommendationDTO
 */
export interface RecommendationDTO {
    /**
     * 
     * @type {string}
     * @memberof RecommendationDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDTO
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDTO
     */
    officialName?: string | null;
    /**
     * 
     * @type {RecomandationStatusEnum}
     * @memberof RecommendationDTO
     */
    state?: RecomandationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RecommendationDTO
     */
    externalEvaluationId?: string;
}

export function RecommendationDTOFromJSON(json: any): RecommendationDTO {
    return RecommendationDTOFromJSONTyped(json, false);
}

export function RecommendationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendationDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'officialName': !exists(json, 'officialName') ? undefined : json['officialName'],
        'state': !exists(json, 'state') ? undefined : RecomandationStatusEnumFromJSON(json['state']),
        'externalEvaluationId': !exists(json, 'externalEvaluationId') ? undefined : json['externalEvaluationId'],
    };
}

export function RecommendationDTOToJSON(value?: RecommendationDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'officialName': value.officialName,
        'state': RecomandationStatusEnumToJSON(value.state),
        'externalEvaluationId': value.externalEvaluationId,
    };
}

